import styles from "./WhatsappButton.module.scss";
import Whatsapp from "../../assets/imgs/icons/whatsappIcon.svg"

export default function WhatsappButton({ 
  text = "Contactar paciente",
  disabled = false,
  onClick,
}) {

  return (
    <button
        type="button"
        className={`
        ${styles.whatsappButton} 
        ${disabled ? styles.disabledButton : ""} 
        `}
        onClick={!disabled ? onClick : undefined}
        disabled={disabled}
    >
      <div className={styles.iconContainer}>
        <img src={Whatsapp} alt="contactar" />
      </div>
      <span className={styles.buttonText}>{text}</span>
    </button>
  );
}
